
/**
 * Check if the given value is a number and not NaN, Infinity, or -Infinity
 * @param {unknown} value
 */
export function isValidNumber(value: unknown): value is number {
    return typeof value === 'number' &&
      !isNaN(value) &&
      isFinite(value);
}

export const safeNumber = (val: string | undefined, fallback: number = 0) =>
    (notEmpty(val) ? Number(val) : fallback);

/**
 * Converts value to number, or returns fallback if conversion fails or result is NaN, Infinity, or -Infinity
 * @param {unknown} v
 * @param {number} fallback defualt 0
 */
export const toNumberOr = (v: unknown, fallback = 0): number => {
    const n = Number(v);
    return isValidNumber(n) ? n : fallback;
};

/**
 *
 * @param item
 */
export function notEmpty(item: unknown) {
    return typeof item !== 'undefined' && item !== null && item !== '';
}
